import { render } from "./SelectionChart.vue?vue&type=template&id=487ff432"
import script from "./SelectionChart.vue?vue&type=script&lang=js"
export * from "./SelectionChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__